import { IAsyncStateAction } from '../actions/asyncStateAction';
import { INITIAL_ASYNC_STATE, IAsyncState } from '../states/renditionStates';
import { localI18nData } from '../utils/general/resourceBundleServices';
import { entitlementServices } from '../utils/general/entitlementServices';
import _ from 'lodash';

const asyncStateReducer = (state: IAsyncState = INITIAL_ASYNC_STATE, action: IAsyncStateAction) => {
    let ifRequireDataGet = state.ifRequireDataGet;
    switch (action.type) {
        case 'REQUEST_HEADER_JSON_DATA':
            ifRequireDataGet = ifRequireDataGet + 1;
            return { ...state, ifRequireDataGet, RequestSend: true };
        case 'RECEIVE_HEADER_JSON_DATA':
            ifRequireDataGet = ifRequireDataGet - 1;
            const isJP = action.value.metadata.isJP;
            const extendlocalData = localI18nData(isJP);
            Object.assign(action.value.i18n, extendlocalData.data);
            return { ...state, ifRequireDataGet, docHeaderJsonData: action.value };
        case 'REQUEST_INITIAL_DATA':
            ifRequireDataGet = ifRequireDataGet + 1;
            return { ...state, ifRequireDataGet };
        case 'RECEIVE_INITIAL_DATA':
            ifRequireDataGet = ifRequireDataGet - 1;
            const entitlementServiceObj = entitlementServices(action.value.html_components_entitled, action.value.html_components_deaden);
            Object.assign(action.value, entitlementServiceObj);
            return { ...state, ifRequireDataGet, initialData: action.value };
        case 'REQUEST_FOOTER_JSON_DATA':
            ifRequireDataGet = ifRequireDataGet + 1;
            return { ...state, ifRequireDataGet };
        case 'RECEIVE_FOOTER_JSON_DATA':
            ifRequireDataGet = ifRequireDataGet - 1;
            return { ...state, ifRequireDataGet, docFooterJsonData: action.value };
        case 'REQUEST_ANALYST_SUBSCRIPTION_DATA':            
            return { ...state };
        case 'RECEIVE_ANALYST_SUBSCRIPTION_DATA':
            return { ...state, analystSubscriptionData: action.value };
        case 'REQUEST_SUBSCRIBE_AUTHOR_BY_SOEID':            
            return { ...state };
        case 'RECEIVE_SUBSCRIBE_AUTHOR_BY_SOEID':
            return { ...state, subscribeAuthorBySoeidResponse: action.value };
        case 'REQUEST_ECONOMIC_CALENDAR_JSON_DATA':
            return { ...state };
        case 'RECEIVE_ECONOMIC_CALENDAR_JSON_DATA':
            return { ...state, economicCalendarData: action.value };
        case 'REQUEST_EVENT_CALENDAR_JSON_DATA':
            return { ...state };
        case 'RECEIVE_EVENT_CALENDAR_JSON_DATA':
            return { ...state, campaignsData: action.value };
        case 'REQUEST_ALL_CAMPAIGNS_DATA':
            return { ...state };
        case 'RECEIVE_ALL_CAMPAIGNS_DATA':
            return { ...state, campaignsData: action.value };
        case 'REQUEST_BODY_JSON_DATA':
            return { ...state };
        case 'RECEIVE_BODY_JSON_DATA':
            // Important!!! the logic get body.json from mock data.It replace by RECEIVE_BODY_JSON_DATA_ONE_BY_ONE now!!
            return { ...state, docBodyJsonData: action.value };
        case 'REQUEST_BODY_JSON_DATA_ONE_BY_ONE':
            return { ...state };
        case 'RECEIVE_BODY_JSON_DATA_ONE_BY_ONE':
            // Important!!! the logic get body.json from backend one by one.
            const _docBodyJsonData = state.docBodyJsonData.concat(action.value);
            return { ...state, docBodyJsonData: _docBodyJsonData };
        case 'REQUEST_FLIP_VERISON_DOC':
            return { ...state };
        case 'RECEIVE_FLIP_VERISON_DOC':
            return { ...state, flipVersionData: action.value };
        case 'REQUEST_ORIGIN_FLIP_VERISON_DOC':
            return { ...state };
        case 'RECEIVE_ORIGIN_FLIP_VERISON_DOC':
            // Add below logic and combine multiCompanyBullBear.tsx's new logic can ensure that open bullBear only send one times request for each company bullBear
            // (Because old rendition will always send request when open bullBear rather than save data for next time use)
            let _originFlipVersionData: any = {};
            const _originDocId = action.originDocId;
            const _originDocData: any = {};
            _originDocData[_originDocId] = action.value;
            if (_.isEmpty(state.originFlipVersionData)) {
                Object.assign(_originFlipVersionData, _originDocData);
            } else {
                _originFlipVersionData = Object.assign(state.originFlipVersionData, _originDocData);
            }
            return { ...state, originFlipVersionData: _originFlipVersionData };
        case 'REQUEST_MULTI_COMPANY_SECTION':
            return { ...state };
        case 'RECEIVE_MULTI_COMPANY_SECTION':
            let _sectionData: any = null;
            if (_.isEmpty(state.sectionData)) {
                _sectionData = action.value;
            } else {
                _sectionData = {
                    documentContent: state.sectionData.documentContent.concat(action.value.documentContent),
                    section: action.value.section
                };
            }
            return { ...state, sectionData: _sectionData };
        case 'REQUEST_COPY_URL':
            return { ...state };
        case 'RECEIVE_COPY_URL':
            return { ...state, copyURLData: action.value };
        case 'REQUEST_COPY_FIGURE_URL':
            return { ...state };
        case 'RECEIVE_COPY_FIGURE_URL':
            return { ...state, copyFigureURLData: action.value };
        case 'REQUEST_CV_MENU_DATA':
            return { ...state, isCVMenuGot: false };
        case 'RECEIVE_CV_MENU_DATA':
            return { ...state, isCVMenuGot: true, cvMenuJsonData: action.value };
        case 'REQUEST_CAMPAIGNS_DATA':
            return { ...state };
        case 'RECEIVE_CAMPAIGNS_DATA':
            return { ...state, campaignsSource: action.value };
        case 'REQUEST_EVENTS_DATA':
            return { ...state };
        case 'RECEIVE_EVENTS_DATA':
            return { ...state, eventsSource: action.value };
        case 'REQUEST_STYLE_FACTORS_DATA':
            return { ...state };
        case 'RECEIVE_STYLE_FACTORS_DATA':
            let _multiStyleFactorCompanies: any = state.multiStyleFactorCompanies || [];
            let _styleFactorsData: any = state.styleFactorsData;
            const quantCharts = action.value.data;
            if (_.isEmpty(state.styleFactorsData) && !_.isEmpty(quantCharts)) {
                _styleFactorsData = quantCharts;
                _multiStyleFactorCompanies.push(quantCharts[0].companyCode);
            } else if (window.HTML_RENDITION.isMCN && !_.isEmpty(quantCharts) && _multiStyleFactorCompanies.indexOf(quantCharts[0]?.companyCode) < 0) {
                _styleFactorsData = _styleFactorsData.concat(quantCharts);
                _multiStyleFactorCompanies = _multiStyleFactorCompanies.concat(quantCharts[0].companyCode);
            }
            return { ...state, styleFactorsData: _styleFactorsData, multiStyleFactorCompanies: _multiStyleFactorCompanies };
        case 'REQUEST_STACKS_TRENDING_DATA':
            return { ...state, stacksTrendingData: { data: {}, isDataGot: false } };
        case 'RECEIVE_STACKS_TRENDING_DATA':
            return { ...state, stacksTrendingData: { data: action.value, isDataGot: true } };
        case 'REQUEST_STACKS_RELATEDRESEARCH_DATA':
            return { ...state, stacksRelatedResearchData: { data: {}, isDataGot: false } };
        case 'RECEIVE_STACKS_RELATEDRESEARCH_DATA':
            return { ...state, stacksRelatedResearchData: { data: action.value, isDataGot: true } };
        case 'REQUEST_STACKS_REC_DATA':
            return { ...state, stacksRecData: { data: {}, isDataGot: false } };
        case 'RECEIVE_STACKS_REC_DATA':
            return { ...state, stacksRecData: { data: action.value, isDataGot: true } };
        case 'REQUEST_STACKS_POP_DATA':
            return { ...state, stacksRecData: { data: {}, isDataGot: false } };
        case 'RECEIVE_STACKS_POP_DATA':
            return { ...state, stacksPopData: { data: action.value, isDataGot: true } };
        case 'REQUEST_STACKS_MORE_REC_DATA':
        case 'REQUEST_STACKS_MORE_POP_DATA':
            return { ...state, moreStacksData: { data: {}, isDataGot: false } };
        case 'RECEIVE_STACKS_MORE_POP_DATA':
        case 'RECEIVE_STACKS_MORE_REC_DATA':
            return { ...state, moreStacksData: { data: action.value, isDataGot: true } };
        case 'REQUEST_REPORTING_CALENDAR_DATA':
            return { ...state, reportingCalendarData: { data: {}, isDataGot: false } };
        case 'RECEIVE_REPORTING_CALENDAR_DATA':
            return { ...state, reportingCalendarData: { data: action.value, isDataGot: true } };
        case 'REQUEST_CATALYST_WATCH_DATA':
            return { ...state };
        case 'RECEIVE_CATALYST_WATCH_DATA':
            return { ...state, catalystWatchData: action.value };
        case 'REQUEST_CRM_USER_DETAILS_DATA':
            return { ...state };
        case 'RECEIVE_CRM_USER_DETAILS_DATA':
            return { ...state, crmUserDetailsData: action.value };
        case 'REQUEST_MAIL_DATA':
            return { ...state, mailResponse: null };
        case 'RECEIVE_MAIL_DATA':
            return { ...state, mailResponse: action.value };
        case 'REQUEST_FP_FIGURE_GALLERY_DATA':
            return { ...state };
        case 'RECEIVE_FP_FIGURE_GALLERY_DATA':
            return { ...state, FPfigureGalleryData: action.value };
        case 'REQUEST_FIGURE_GALLERY_DATA':
            return { ...state };
        case 'RECEIVE_FIGURE_GALLERY_DATA':
            return { ...state, figureGalleryData: action.value };
        case 'REQUEST_FORECAST_DATA':
            return { ...state };
        case 'RECEIVE_FORECAST_DATA':
            const data: any = state.forecastData;
            data[action.value.forecastType] = { data: action.value.data, isDataGot: true };
            return { ...state, forecastData: data };
        case 'REQUEST_FINSUM_DATA':
            return { ...state };
        case 'RECEIVE_FINSUM_DATA':
            return { ...state, finSumData: action.value };
        case 'RECEIVE_FINSUM_ERROR':
            return { ...state, finSumData: { isError: true } };
        case 'REQUEST_FOCUS_LIST':
            return { ...state, focusListData: { data: {}, isDataGot: false } };
        case 'RECEIVE_FOCUS_LIST':
            return { ...state, focusListData: { data: action.value, isDataGot: true } };
        case 'REQUEST_RELATED_PUBLICATIONS':
            return { ...state };
        case 'RECEIVE_RELATED_PUBLICATIONS':
            return { ...state, relatedPublicationsData: action.value };
        case 'REQUEST_PRICECHART_DATA':
            return { ...state };
        case 'RECEIVE_PRICECHART_DATA':
            return { ...state, priceChartData: action.value };
        case 'REQUEST_REPORTS_TO_REVISIT_DATA':
            return { ...state };
        case 'RECEIVE_REPORTS_TO_REVISIT_DATA':
            return { ...state, reportsToRevisit: action.value };
        case 'REQUEST_BOOK_MEETING_DATA':
            return { ...state };
        case 'RECEIVE_BOOK_MEETING_DATA':
            return { ...state, bookMeetingEntitlement: action.value };
        case 'REQUEST_CV_MACRO_TOOLS_DATA':
            return { ...state };
        case 'RECEIVE_CV_MACRO_TOOLS_DATA':
            return { ...state, cvMacroToolsData: action.value };
        case 'REQUEST_THEMES_DATA':
            return { ...state };
        case 'RECEIVE_THEMES_DATA':
            return { ...state, themesData: action.value };
        case 'REQUEST_ESG_TABLE_DATA':
            return { ...state };
        case 'RECEIVE_ESG_TABLE_DATA':
            return { ...state, esgData: action.value };
        case 'REQUEST_RESTRICTION_DETAILS_DATA':
            return { ...state };
        case 'RECEIVE_RESTRICTION_DETAILS_DATA':
            return { ...state, restrictionDetailsData: action.value };
        case 'REQUEST_ANALYST_INFO_BY_NAME':
            return { ...state };
        case 'RECEIVE_ANALYST_INFO_BY_NAME':
            return { ...state, analystInfoDataByName: action.value };
        case 'REQUEST_ANALYST_INFO_BY_ID':
            return { ...state };
        case 'RECEIVE_ANALYST_INFO_BY_ID':
            return { ...state, analystInfoDataById: action.value };
        case 'REQUEST_POLL_DATA':
            return { ...state };
        case 'RECEIVE_POLL_DATA':
            let _pollData: any = {};
            const _pollId = action.pollId;
            const _pollResultsData: any = {};
            _pollData = {
                pollData: action.value,
                pollId: action.pollId,
            };
            Object.assign(_pollResultsData, _pollData);
            return { ...state, pollResultsData: _pollResultsData };
        case 'REQUEST_RELATED_REPORT_DATA':
            return { ...state };
        case 'RECEIVE_RELATED_REPORT_DATA':
            return { ...state, relatedReportSectionData: action.value };
        case 'REQUEST_REGION_BAR_DATA':
            return { ...state };
        case 'RECEIVE_REGION_BAR_DATA':
            let _urlData: any = null;
            if (!_.isNull(action.value)) { _urlData = action.value["data"]; }
            return { ...state, urlData: _urlData };
        case 'REQUEST_FLAGSHIP_PERIODICAL_DATA':
            return { ...state };
        case 'RECEIVE_FLAGSHIP_PERIODICAL_DATA':
            return { ...state, flagshipPeriodicals: action.value };
        case 'REQUEST_SESSION_CONTEXT_DATA':
            return { ...state };
        case 'RECEIVE_SESSION_CONTEXT_DATA':
            return { ...state, sessionContext: action.value };
        case 'REQUEST_PLATFORM_ID_DATA':
            return { ...state };
        case 'RECEIVE_PLATFORM_ID_DATA':
            return { ...state, platformIdData: action.value };
        case 'REQUEST_EXCLUDE_COPY_FIGURE_PLATFORM_ID_DATA':
            return { ...state };
        case 'RECEIVE_EXCLUDE_COPY_FIGURE_PLATFORM_ID_DATA':
            return { ...state, excludeCopyFigurePlatformIdData: action.value };
        case 'REQUEST_CLICKTHRU_JSON_DATA':
        return { ...state };
        case 'RECEIVE_CLICKTHRU_JSON_DATA':
            return { ...state, clickThruJsonData: action.value };
        case 'REQUEST_GLOBAL_MARKET_DATA':
            return { ...state };
        case 'RECEIVE_GLOBAL_MARKET_DATA':
            return { ...state, globalMarketData: action.value };
        case 'REQUEST_KEY_DATA_CHANGE_DATA':
            return { ...state };
        case 'RECEIVE_KEY_DATA_CHANGE_DATA':
            return { ...state, keyDataChangeData: action.value };
        case 'REQUEST_MUST_READ_SECTION_DATA':
            return { ...state };
        case 'RECEIVE_MUST_READ_SECTION_DATA':
            return { ...state, mustReadSectionData: action.value };
        case 'REQUEST_PRESENTATION_HTML_DATA':
            return { ...state };
        case 'RECEIVE_PRESENTATION_HTML_DATA':
            return { ...state, presentationHTMLData: action.value };
        case 'REQUEST_PRESENTATION_JSON_DATA':
            return { ...state };
        case 'RECEIVE_PRESENTATION_JSON_DATA':
            return { ...state, presentationJSONData: action.value };
        case 'SET_PREVIOUS_REQUEST_ID': 
            return { ...state, previousRequestId: action.value }
        case 'SET_PAGE_NUMBER': 
            return { ...state, pageNumber: action.value }
        case 'REQUEST_FILE_URL_PATH':
            return { ...state }
        case 'RECEIVE_FILE_URL_PATH':
            return { ...state, fileUrl: action.value }
        case 'REQUEST_SEND_EMAIL':
            return { ...state }
        case 'RECEIVE_SEND_EMAIL':
            return { ...state, sendEmailData: action.value }
        case 'REQUEST_ANALYST_MODEL':
            return { ...state }
        case 'RECEIVE_ANALYST_MODEL':
            return { ...state, analystModelData: action.value }
        case 'REQUEST_COMPANY_COVERAGE_BY_TICKER':
            return { ...state }
        case 'RECEIVE_COMPANY_COVERAGE_BY_TICKER':
            return { ...state, companyCoverageByTicker: action.value }
        case'RECEIVE_COMPANY_COVERAGE_BY_CODE':
            return { ...state, companyCoverageByCode: action.value }
        case 'REQUEST_USER_ENTITLEMENTS':
            return { ...state }
        case 'RECEIVE_USER_ENTITLEMENTS':
            return { ...state, userEntitlements: action.value }
        case 'RECEIVE_EXPECTED_PERFORMANCE':
            return { ...state, expectedPerformance: action.value }
        case 'UPDATE_ANALYST_MODEL_LOADER':
            return { ...state, analystModelLoader: action.value }
        case 'UPDATE_SEND_EMAIL_ERROR':
            return { ...state, sendEmailError: action.value }
        default:
            return state;
    }
};

export default asyncStateReducer;
